import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { DmtUtilityService } from '../../../../../../services/dashboard/dmt-utility.service';
import { NtRegionalAccessMonitoringInterface } from '../../../../../../shared/interfaces/nt-regional-access-monitoring.interface';

@Component({
  selector: 'app-monitoring-forecast-vs-actual-regional-level',
  imports: [CommonModule],
  templateUrl: './monitoring-forecast-vs-actual-regional-level.component.html',
  styleUrl: './monitoring-forecast-vs-actual-regional-level.component.css'
})
export class MonitoringForecastVsActualRegionalLevelComponent implements OnInit {
  isLoading: boolean = true;

  public medicineId: number = 0;
  public companyId: number = 0;
  public countryId: number = 1;

  rows: NtRegionalAccessMonitoringInterface[] = [];

  constructor(private us: DmtUtilityService, private dataService: DataService) { }

  ngOnInit(): void {
    this.getSessionVariables();
    this.dataService.getRegionalAccessMonitoringData(this.companyId,this.medicineId,this.countryId).subscribe(data=>{
      console.log("dati ricevuti",data)
      this.rows=data;
      this.rows.sort((a,b)=>a.regionName.localeCompare(b.regionName))
      this.isLoading=false;
    })
  }


  getStatusDelta(delta:number){
    let bgClass;

  if (delta === 0) {
        bgClass = 'bg-white';
      } else if (delta > 0) {
        bgClass='bg-red-100'
      } else if (delta < 0) {
        bgClass = 'bg-green-100';
      }
      return bgClass;
  }

  getSessionVariables() {
   this.medicineId = this.us.getSessionVariableNumber('medicineId', 0);
this.countryId = this.us.getSessionVariableNumber('countryId');
this.companyId = this.us.getSessionVariableNumber('companyId', 0);

console.log("medicineId", this.medicineId);
console.log("countryId", this.countryId);
console.log("companyId", this.companyId);

  }
}